import { DataProvider, IComponentModel, IListComponentModel } from "@nf/common";
import { ROUTES } from "@nf/constants";
import { GetServerSideProps } from "next";

import dynamic from "next/dynamic";

import { captureMessage } from "@sentry/nextjs";
import { getCommonServerSideProps } from "../../../../helpers/getCommonServerSideProps";

const MainScreen = dynamic(() => import("screens/MainScreen"));

export const getServerSideProps: GetServerSideProps = async (ctx: any) => {
  const setCacheHeader = await import("helpers").then(
    (mod) => mod.setCacheHeader
  );
  const getComponentsMediaListData = await import("SSRUtils").then(
    (mod) => mod.getComponentsMediaListData
  );

  const { commonProps } = await getCommonServerSideProps(ctx);

  setCacheHeader(ctx.res);

  try {
    const screenData = await DataProvider.getScreenConfiguration(ctx.params.id);

    const componentData: IComponentModel[] = await getComponentsMediaListData(
      screenData?.Components as IListComponentModel[]
    );

    return {
      props: {
        ...commonProps,
        componentData,
        screenData,
      },
    };
  } catch (e: any) {
    captureMessage(e.Message, {
      level: "warning",
      tags: {
        componentConfiguration: ctx?.params?.id,
        error: e,
      },
    });
    return {
      redirect: {
        destination: `/${commonProps.country}/${commonProps.lang}${ROUTES.PAGE_NOT_FOUND}`,
      },
      props: {
        ...commonProps,
      },
    };
  }
};

export default MainScreen;
